import {
  COMB_PREM,
  FIXED_VALUE,
  MATCH_PREMIUM_WITH_MAX_DIFF,
  NO_MATCHING,
  ORDER_TYPE_M,
  PREMIUM_CLOSE_TO,
  PREMIUM_RANGE,
  SEGMENT_OPTIONS,
  SQ_OFF_LEG,
  TRADING_TYPE_INTRADAY,
  UNDERLYING_INDEX,
} from '@quantiply/common/constants';

export const createLegDefault = {
  base: 'NIFTY',
  segment: SEGMENT_OPTIONS,
  side: 'CE',
  transactionType: 'B',
  quantity: 1,
  strike: 'ATM',
};

export const configurationsDefault = {
  underlying: UNDERLYING_INDEX,
  startTime: '09:15:00',
  endTime: '15:15:00',
  moveStoplossToCost: false,
  isWaitAndTradeEnabled: false,
  tradeOnlyFirstEntry: false,
  isReEntryEnabled: false,
  stoplossSquareOffBy: ORDER_TYPE_M,
  entryOrderType: ORDER_TYPE_M,
  matching: [
    {
      mode: NO_MATCHING,
      active: true,
    },
    {
      mode: MATCH_PREMIUM_WITH_MAX_DIFF,
      active: false,
      maxDiff: 1,
    },
    {
      mode: PREMIUM_CLOSE_TO,
      active: false,
      premiumCloseTo: 1,
    },
    {
      mode: PREMIUM_RANGE,
      active: false,
      lower: 1,
      upper: 1,
    },
    {
      mode: COMB_PREM,
      active: false,
      type: 'LT',
      val1: 1,
    },
  ],
  legs: [],
  tradingType: TRADING_TYPE_INTRADAY,
  trailingInterval: {
    frequency: 'M',
    value: 1,
  },
  legsAction: SQ_OFF_LEG,
  entryOrderLimitPrice: {
    type: FIXED_VALUE,
    value: 5,
  },
  entryOrderTimeoutSeconds: 5,
  stoplossLimitPrice: {
    type: FIXED_VALUE,
    value: 5,
  },
  limitOrderTimeoutSeconds: 5,
  endDay: 0,
  entryOrderDelayType: null,
  exitOrderDelayType: null,
};
